import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Month } from '../models/allocation.model';

export interface YearMonthOption {
  label: string;
  value: number;
}

/** Shared year/month filter for main header. Used by allocation and forecast pages. Defaults to current year/month; user can change. */
@Injectable({ providedIn: 'root' })
export class YearMonthFilterService {
  private readonly today = new Date();
  private year$ = new BehaviorSubject<number>(this.today.getFullYear());
  private month$ = new BehaviorSubject<Month>((this.today.getMonth() + 1) as Month);

  readonly year = this.year$.asObservable();
  readonly month = this.month$.asObservable();

  get currentYear(): number {
    return this.year$.value;
  }

  get currentMonth(): Month {
    return this.month$.value;
  }

  setYear(value: number): void {
    this.year$.next(value);
  }

  setMonth(value: Month): void {
    this.month$.next(value);
  }

  getYearOptions(): YearMonthOption[] {
    const currentYear = this.today.getFullYear();
    const options: YearMonthOption[] = [];
    for (let y = currentYear - 2; y <= currentYear + 2; y++) {
      options.push({ label: String(y), value: y });
    }
    return options;
  }

  getMonthOptions(): YearMonthOption[] {
    return [
      { label: 'January', value: Month.January },
      { label: 'February', value: Month.February },
      { label: 'March', value: Month.March },
      { label: 'April', value: Month.April },
      { label: 'May', value: Month.May },
      { label: 'June', value: Month.June },
      { label: 'July', value: Month.July },
      { label: 'August', value: Month.August },
      { label: 'September', value: Month.September },
      { label: 'October', value: Month.October },
      { label: 'November', value: Month.November },
      { label: 'December', value: Month.December }
    ];
  }
}
